import {isFeatureEnabled} from 'feature-flags';

import {GetArticleResponse} from '@dms/api/warehouse';
import {featureFlags} from '@dms/feature-flags';

import {Nullish} from 'shared/web';

/**
 * @about Read the warehouse ACL scopes of an article from GET v6 `allowedPermissions`.
 * A missing object or a missing flag means the action is allowed, and so does a disabled
 * `AFS_WAREHOUSE_ACL_SCOPES` flag, so the card behaves as before the ACL scopes.
 */
export function getArticleAllowedPermissions(article: GetArticleResponse | Nullish) {
  const allowedPermissions = isFeatureEnabled(featureFlags.AFS_WAREHOUSE_ACL_SCOPES)
    ? article?.allowedPermissions
    : undefined;

  return {
    canEdit: allowedPermissions?.edit !== false,
    canManualReservation: allowedPermissions?.manualReservation !== false,
    canRename: allowedPermissions?.rename !== false,
    canChangePrices: allowedPermissions?.changePrices !== false,
  };
}
